<template>
  <div class="content">
    <div class="content_title">
      Типы проезжающих
    </div>
      <div
        v-for="(type, key) in kppTypes" class="content_row" v-bind:key = "key">
        <div>
          Название типа проезжающих: {{type.NAME}}
        </div>
        <div>
          Способ: {{ type.METHOD?methodVocab[type.METHOD]:'' }}
        </div>
        <div>
          Срочность пропусков: {{ type.TIME }}
        </div>
        <div>
          Реализация пропусков: {{ type.REALISATION }}
        </div>
        <div v-show="type.REALISATION=='Платный'">
          Услуга: {{ type.SERVICE_ID?services[type.SERVICE_ID].NAME:'' }}
        </div>
        <div>
          Группа доступа: {{ type.PARSEC_GROUP_ID?parsecgroups[type.PARSEC_GROUP_ID].NAME:'' }}
        </div>
        <div>
          <button @click="unloadPasses(type.PARSEC_GROUP_ID)">
            Выгрузить пропуски
          </button>
        </div>
      </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetIntegrationTypes",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      parsecAccounts: [],
      showLink: true,
      showAddIntegration: false,
      showAddKpp: false,
      login: "",
      methodVocab: {
        'auto': 'Автоматический',
        'manual': 'Ручной'
      },
      password: "",
      server_ip: "",
      type_name: "Парсек",
      villages: [],
      kppName: '',
      kppIdVillages: [],
      kppTypes: [],
      services: [],
      parsecgroups: [],
      kppId: this.$route.params.id,
      kpps: []
    };
  },
  computed: {},
  watch: {
    updateList: function(state) {
      if (state) {
        this.getParsecAccounts();
      }
    }
  },
  methods: {
    updateTypes: function() {
      this.$refs.types_link.getGroupsData();
    },
    getVillages: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "villages/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
          }
        });
    },
    getTypes: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "kpptypes/get/",
          filter: {'KPP_ID': self.kppId},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.kppTypes = data;
          }
        });
    },
    getKpps: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "kpp/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.kpps = data;
          }
        });
    },
    getServices: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getAccessGroups: function (){

      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecgroups = data;
          }
        });
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xls"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    unloadPasses(group_id) {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecpasses/get-passes-file/",
          responseType: "arraybuffer",
          method: "POST",
          data: {
            GROUP_ID: group_id
          }
        })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    }
  },
  created() {
    this.getKpps();
    this.getAccessGroups();
    this.getServices();
    this.getTypes();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
